
import { User, LoginCredentials, AuthResponse, LoginRequest, LoginResponse } from '../models/User';
import { authService } from '../services/authService';
import { secureTokenManager } from '../utils/secureTokenManager';

export class AuthViewModel {
  private _user: User | null = null;
  private _isAuthenticated: boolean = false;
  private _isLoading: boolean = false;
  private _error: string | null = null;

  // Getters
  get user(): User | null {
    return this._user;
  }

  get isAuthenticated(): boolean {
    return this._isAuthenticated;
  }

  get isLoading(): boolean {
    return this._isLoading;
  }

  get error(): string | null {
    return this._error;
  }

  // Methods
  async login(credentials: LoginCredentials): Promise<boolean> {
    this._isLoading = true;
    this._error = null;

    try {

      // Call the real API
      const response = await authService.login({
        email: credentials.email,
        password: credentials.password
      });

      if (response.success && response.data) {
        // Map API response to our User interface
        const user: User = {
          id: response.data.user.id,
          fullName: response.data.user.fullName,
          email: response.data.user.email,
          role: response.data.user.role,
          accountStatus: response.data.user.status,
          createdOn: '', // Not provided in login response
          lastLogin: response.data.user.lastLogin
        };

        this._user = user;
        this._isAuthenticated = true;
        sessionStorage.setItem('token', response.data.token);
        sessionStorage.setItem('user', JSON.stringify(user));
        secureTokenManager.setLoginTimestamp();

        return true;
      }

      this._error = response.message || 'Login failed';
      return false;
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : 'Login failed';
      this._error = errorMessage;
      console.error('❌ Login failed:', errorMessage);
      return false;
    } finally {
      this._isLoading = false;
    }
  }

  logout(): void {
    this._user = null;
    this._isAuthenticated = false;
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('user');
    secureTokenManager.clearAllTokens();
  }

  checkAuthStatus(): void {
    const token = sessionStorage.getItem('token');
    const userStr = sessionStorage.getItem('user');

    if (token && userStr) {
      // Check if session is valid (within 24 hours)
      if (!secureTokenManager.checkSessionValid()) {
        this.logout();
        return;
      }

      try {
        const user = JSON.parse(userStr);
        this._user = user;
        this._isAuthenticated = true;
      } catch {
        this.logout();
      }
    }
  }

}
